import React from 'react';
import { Text } from '@wix/design-system';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { MONEY_BACK_LABEL_KEY } from '../../hooks';
import s from './MoneyBackHoverLabel.scss';

export const moneyBackHoverCtaClassName = s.cta;

export const MoneyBackHoverLabel = () => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();

  return (
    <Text
      size="tiny"
      weight="thin"
      dataHook="cta-money-back-label"
      className={s.label}
    >
      {t(MONEY_BACK_LABEL_KEY)}
    </Text>
  );
};
